import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '@/api/baseQuery';
import { UUID } from '@/types';
import { useDatasourceId } from '@/hooks';

export const GENERATE_SUGGESTED_QUERY = 'generateSuggestedQuery';

export const suggestedQueriesApiSlice = createApi({
  reducerPath: 'suggestedQueriesApiSlice',
  baseQuery,
  endpoints: (builder) => ({
    [GENERATE_SUGGESTED_QUERY]: builder.mutation<
      { queryId: UUID },
      { datasourceId: UUID; payload: { sql: string } }
    >({
      query: ({ datasourceId, payload }) => ({
        url: `datasources/${datasourceId}/suggested-queries/generate`,
        method: 'POST',
        body: payload,
      }),
    }),
  }),
});

export const { useGenerateSuggestedQueryMutation } = suggestedQueriesApiSlice;

export const useGenerateSuggestedQuery = () => {
  const datasourceId = useDatasourceId();
  const [mutate, result] = useGenerateSuggestedQueryMutation();

  const handleMutate = (sql: string) =>
    mutate({ datasourceId, payload: { sql } });

  return [handleMutate, result] as const;
};
